import { Lihe } from "@/service/CatalogApiService/catalog.types";
import { Booking } from "../../../../requests-module/src";

export const trainSecRoundTripLihes = ["186909", "186916", "186911", "186910", "186919", "186881"];

export const trainSecOneDirectionLihes = ["197630","197631","197632","197633","197634","197635", "197828", "197829", "197830", "197831", "197832", "197833"];

export const trainSecWeekendLihes = ["187150"];

function checkIsPackageTrainOnly(product: Lihe | null, booking?: Booking | null): boolean {
    if (booking?.packageCode === 'TNE') return true;
    if (!product) return false;
    if (trainSecRoundTripLihes.includes(product.liheId.toString()) || trainSecOneDirectionLihes.includes(product.liheId.toString()) || trainSecWeekendLihes.includes(product.liheId.toString())) {
        return true
    }
    return false
}

export const isCabinTrainOnly = (optionName: string): boolean => {
    if (optionName.includes('Couchette')) {
        return false
    }
    return true
}

export default checkIsPackageTrainOnly